// assets/images.js
export const DEFAULT_EVENT_IMAGE = "/images/evenements_a_venir.png";
export const DEFAULT_PARTNER_LOGO = "/images/partenaires.png";